import { CardMedia } from '@mui/material';
import ClaimZsImage from 'assets/images/img-claim-zs.jpg';

const MissingImage = () => (
  <CardMedia aria-label="Image Missing" component="img" image={ClaimZsImage} />
);

export default MissingImage;
